import { FLOWMAP_CONFIG } from './constants';

export const calculateArrowHeads = (
    startLng,
    startLat,
    endLng,
    endLat,
    volume,
    zoom
) => {
    const { ARROW_ZOOM } = FLOWMAP_CONFIG;

    // Calculate smooth zoom-based scaling
    const zoomDiff = zoom - ARROW_ZOOM.BASE_ZOOM;
    const zoomScale = 1 / Math.pow(ARROW_ZOOM.ZOOM_FACTOR, zoomDiff);

    // Calculate volume-based length
    const volumeScale =
        (volume / ARROW_ZOOM.VOLUME_MAX) * ARROW_ZOOM.VOLUME_SCALE;
    const baseLength = ARROW_ZOOM.BASE_LENGTH + volumeScale;

    // Apply zoom scaling with min/max constraints
    const scaledLength = baseLength * zoomScale;
    const length = Math.max(
        ARROW_ZOOM.MIN_LENGTH,
        Math.min(ARROW_ZOOM.MAX_LENGTH, scaledLength)
    );
    const angle = FLOWMAP_CONFIG.ARROW_ANGLE;

    const toWebMercator = (lng, lat) => {
        const x = (lng * Math.PI) / 180;
        const y = Math.log(Math.tan(Math.PI / 4 + (lat * Math.PI) / 360));
        return [x, y];
    };

    const arrowClockwiseExtraRotationDeg = 10;

    const [startX, startY] = toWebMercator(startLng, startLat);
    const [endX, endY] = toWebMercator(endLng, endLat);

    const bearing = Math.atan2(endX - startX, endY - startY);
    const rotationRad = (arrowClockwiseExtraRotationDeg * Math.PI) / 180;
    const b = bearing + rotationRad;

    const latCorrectionFactor = Math.cos((endLat * Math.PI) / 180);
    const angleRad = (angle * Math.PI) / 180;

    const arrowHead1 = [
        endLng - (length * Math.sin(b + angleRad)) / latCorrectionFactor,
        endLat - length * Math.cos(b + angleRad),
    ];
    const arrowHead2 = [
        endLng - (length * Math.sin(b - angleRad)) / latCorrectionFactor,
        endLat - length * Math.cos(b - angleRad),
    ];

    if (
        !isFinite(arrowHead1[0]) ||
        !isFinite(arrowHead1[1]) ||
        !isFinite(arrowHead2[0]) ||
        !isFinite(arrowHead2[1])
    ) {
        console.warn('Invalid arrow head coordinates calculated');
        return [];
    }

    return [
        {
            type: 'LineString',
            coordinates: [[endLng, endLat], arrowHead1],
        },
        {
            type: 'LineString',
            coordinates: [[endLng, endLat], arrowHead2],
        },
    ];
};
